<template lang="pug">
.offer-sidebar-wrapper
  .top
    .offer-details(v-for="offer, idx in offers")
      .od-top Angebot {{idx + 1}}
        b-button(type="is-text" icon-right="close" @click="$store.commit('offers/removeSelectedOffer', idx); $emit('refresh')")
      .od-line {{offer.rentObject.name}}
      .od-line {{formatDate(offer.startDate)}} - {{formatDate(offer.endDate)}}
  .bottom-buttons
    b-button(type="is-light" @click="$store.commit('offers/resetSelectedOffers'); $emit('refresh'); $emit('close')") Abbrechen
    b-button(type="is-primary" @click="$router.push({name: 'OfferBooking'})") Angebote erstellen  
</template>

<script>
import { DateTime } from "luxon";

export default {
  props: {
    offers: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    offers(newVal) {
      if (newVal.length <= 0 ) {
        this.$emit("close");
      }
    }
  },
  methods: {
    formatDate(d) {
      d = new Date(d);
      const dt = DateTime.fromJSDate(d);
      return dt.setLocale('de')
        .toFormat('dd. LLL. yyyy')
    },
  }
}
</script>

<style lang="scss" scoped>
.offer-sidebar-wrapper {
  position: fixed;
  z-index: 2;
  top: 260px;
  right: 0;
  width: 320px;
  height: calc(100vh - 260px);
  background-color: $light;
  border: solid 1px $lightgray;;
  .top {
    height: calc(100% - 56px);
    overflow-y: auto;
  }
}

.bottom-buttons {
  display: flex;
  justify-content: space-around;
}

.offer-details {
  margin: $xs-space;
  padding: $xs-space;
  border-radius: 3px;
  background-color: white;
  .od-top {
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .od-top {
    font-weight: 500;
  }
}
</style>